<template>
  <router-view />
</template>

<script>
export default {
  name: 'DashboardCoreView',
}
</script>
